import { AppHeader } from 'packages/lib/common-ui/app-shell/app-header';
import { Layout, ConfigProvider, theme } from 'antd';
import { FC, PropsWithChildren, Suspense } from 'react';
import { AnnotationToolLayoutProps } from 'packages/at-shell/components/app-shell/app-layout';

const { Content } = Layout;

export const AppLayout: FC<
  PropsWithChildren<{ colorTheme?: AnnotationToolLayoutProps['theme'] }>
> = ({ children, colorTheme }) => {
  return (
    <ConfigProvider
      theme={{
        algorithm: [
          colorTheme === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
          theme.compactAlgorithm,
        ],
      }}
    >
      <Layout style={{ height: '100vh', width: '100vw', color: '#000' }}>
        <Layout style={{ height: '100%' }}>
          <AppHeader />
          <Content
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              position: 'relative',
            }}
          >
            <Suspense fallback={null}>{children}</Suspense>
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
export default AppLayout;
